import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row g-2 align-items-start" }
const _hoisted_2 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_3 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_4 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_5 = { class: "col-12 col-md-6 col-xl" }
const _hoisted_6 = { class: "col-12 col-xl-auto" }
const _hoisted_7 = { class: "errors" }
const _hoisted_8 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_9 = { class: "row g-2 align-items-start" }
const _hoisted_10 = { class: "col-12 col-md" }
const _hoisted_11 = { class: "col-12 col-md" }
const _hoisted_12 = { class: "col-12 col-md-auto" }
const _hoisted_13 = { class: "errors" }
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_QuickRangeButtons = _resolveComponent("QuickRangeButtons")!
  const _component_Events = _resolveComponent("Events")!
  const _component_EngineSpeed = _resolveComponent("EngineSpeed")!
  const _component_Fuel = _resolveComponent("Fuel")!
  const _component_Voltage = _resolveComponent("Voltage")!
  const _component_SummaryView = _resolveComponent("SummaryView")!
  const _component_Speed = _resolveComponent("Speed")!
  const _component_BorderCrossing = _resolveComponent("BorderCrossing")!
  const _component_WeeklyReport = _resolveComponent("WeeklyReport")!
  const _component_Ignition = _resolveComponent("Ignition")!
  const _component_Geofencing = _resolveComponent("Geofencing")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Tabs, null, {
      "tab-selector": _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_REPORTS }, "tab-link"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab(_ctx.TAB_REPORTS)))
        }, _toDisplayString(_ctx.$t('components.reports.tabs.reports')), 3),
        _createElementVNode("button", {
          class: _normalizeClass([{active: _ctx.tabContent === _ctx.TAB_STATISTICS }, "tab-link"]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab(_ctx.TAB_STATISTICS)))
        }, _toDisplayString(_ctx.$t('components.reports.tabs.statistics')), 3)
      ]),
      "tab-content": _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.v.dateFrom.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v.dateFrom.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.dateFrom.$error, 'is-invalid': _ctx.v.dateFrom.$error }),
                placeholder: _ctx.$t('components.datepicker.startPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitStartDate
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.v.dateTo.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v.dateTo.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.dateTo.$error, 'is-invalid': _ctx.v.dateTo.$error }),
                placeholder: _ctx.$t('components.datepicker.endPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitEndDate
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_vue_select, {
                modelValue: _ctx.v.imei.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v.imei.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.imei.$error, 'is-invalid': _ctx.v.imei.$error }),
                options: _ctx.vehicles,
                icon: "bi bi-truck",
                label: "label",
                onUpdateSelect: _ctx.emitVehicle
              }, null, 8, ["modelValue", "class", "options", "onUpdateSelect"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_vue_select, {
                modelValue: _ctx.v.reportType.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v.reportType.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.reportType.$error, 'is-invalid': _ctx.v.reportType.$error }),
                options: _ctx.reportTypes,
                icon: "bi bi-graph-up-arrow",
                label: "value",
                onUpdateSelect: _ctx.emitReportType
              }, null, 8, ["modelValue", "class", "options", "onUpdateSelect"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-success btn-search w-100",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.search(_ctx.TAB_REPORTS)))
              }, _toDisplayString(_ctx.$t('components.reports.search')), 1)
            ])
          ]),
          _createVNode(_component_QuickRangeButtons, { onRangeSelected: _ctx.applyQuickRange }, null, 8, ["onRangeSelected"]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.v.dateFrom.$error || _ctx.v.dateTo.$error || _ctx.v.imei.$error || _ctx.v.reportType.$error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('customValidators.allMustBeCompleted')), 1))
              : _createCommentVNode("", true)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            key: _ctx.searched[_ctx.TAB_REPORTS]
          }, [
            (_ctx.reportType === 'events_list')
              ? (_openBlock(), _createBlock(_component_Events, {
                  key: 0,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  imei: _ctx.imei,
                  "report-type": _ctx.reportType,
                  vehicle: _ctx.vehicle
                }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"]))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'engine_speed')
              ? (_openBlock(), _createBlock(_Suspense, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EngineSpeed, {
                      "date-from": _ctx.dateFrom,
                      "date-to": _ctx.dateTo,
                      imei: _ctx.imei,
                      "report-type": _ctx.reportType,
                      vehicle: _ctx.vehicle
                    }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'fuel')
              ? (_openBlock(), _createBlock(_Suspense, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Fuel, {
                      "date-from": _ctx.dateFrom,
                      "date-to": _ctx.dateTo,
                      imei: _ctx.imei,
                      "report-type": _ctx.reportType,
                      vehicle: _ctx.vehicle
                    }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'voltage')
              ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Voltage, {
                      "date-from": _ctx.dateFrom,
                      "date-to": _ctx.dateTo,
                      imei: _ctx.imei,
                      "report-type": _ctx.reportType,
                      vehicle: _ctx.vehicle
                    }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'summary')
              ? (_openBlock(), _createBlock(_component_SummaryView, {
                  key: 4,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  imei: _ctx.imei,
                  "report-type": _ctx.reportType,
                  vehicle: _ctx.vehicle
                }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"]))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'speed')
              ? (_openBlock(), _createBlock(_Suspense, { key: 5 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Speed, {
                      "date-from": _ctx.dateFrom,
                      "date-to": _ctx.dateTo,
                      imei: _ctx.imei,
                      "report-type": _ctx.reportType,
                      vehicle: _ctx.vehicle
                    }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'border_crossing')
              ? (_openBlock(), _createBlock(_component_BorderCrossing, {
                  key: 6,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  imei: _ctx.imei,
                  "report-type": _ctx.reportType,
                  vehicle: _ctx.vehicle
                }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"]))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'weekly_report')
              ? (_openBlock(), _createBlock(_component_WeeklyReport, {
                  key: 7,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  imei: _ctx.imei,
                  "report-type": _ctx.reportType,
                  vehicle: _ctx.vehicle
                }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"]))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'ignition')
              ? (_openBlock(), _createBlock(_Suspense, { key: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Ignition, {
                      "date-from": _ctx.dateFrom,
                      "date-to": _ctx.dateTo,
                      imei: _ctx.imei,
                      "report-type": _ctx.reportType,
                      vehicle: _ctx.vehicle
                    }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.reportType === 'geofencing')
              ? (_openBlock(), _createBlock(_component_Geofencing, {
                  key: 9,
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo,
                  imei: _ctx.imei,
                  "report-type": _ctx.reportType,
                  vehicle: _ctx.vehicle
                }, null, 8, ["date-from", "date-to", "imei", "report-type", "vehicle"]))
              : _createCommentVNode("", true)
          ])), [
            [_vShow, _ctx.searched[_ctx.TAB_REPORTS]]
          ])
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_REPORTS]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.v.dateFrom.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v.dateFrom.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.dateFrom.$error, 'is-invalid': _ctx.v.dateFrom.$error }),
                placeholder: _ctx.$t('components.datepicker.startPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitStartDate
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_date_picker, {
                modelValue: _ctx.v.dateTo.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v.dateTo.$model) = $event)),
                class: _normalizeClass({ 'custom-error': _ctx.v.dateTo.$error, 'is-invalid': _ctx.v.dateTo.$error }),
                placeholder: _ctx.$t('components.datepicker.endPlaceholder'),
                type: 'datetime',
                range: false,
                "start-time": { hours: 0, minutes: 0 },
                "time-picker-inline": true,
                onEmitDate: _ctx.emitEndDate
              }, null, 8, ["modelValue", "class", "placeholder", "onEmitDate"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-success btn-search w-100",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.search(_ctx.TAB_STATISTICS)))
              }, _toDisplayString(_ctx.$t('components.reports.search')), 1)
            ])
          ]),
          _createVNode(_component_QuickRangeButtons, { onRangeSelected: _ctx.applyQuickRange }, null, 8, ["onRangeSelected"]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.v.dateFrom.$error || _ctx.v.dateTo.$error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('customValidators.allMustBeCompleted')), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.searched[_ctx.TAB_STATISTICS])
            ? (_openBlock(), _createElementBlock("div", {
                key: _ctx.searched[_ctx.TAB_STATISTICS]
              }, [
                _createVNode(_component_Statistics, {
                  "date-from": _ctx.dateFrom,
                  "date-to": _ctx.dateTo
                }, null, 8, ["date-from", "date-to"])
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.tabContent === _ctx.TAB_STATISTICS]
        ])
      ]),
      _: 1
    })
  ]))
}